/** Session, account, preferences and the experience (deal-model mode). */
import type { EndpointDef } from '../endpointTypes'

export const coreRoutes = {
  logout: { method: 'POST', path: '/auth/logout', note: 'Ends the current browser session with its CSRF proof' },
  me: { method: 'GET', path: '/api/me', note: 'Current user; carries the CSRF token for writes' },
  entitlements: { method: 'GET', path: '/api/me/entitlements' },
  preferences: { method: 'GET', path: '/api/me/preferences', note: 'Saved filters, register defaults (dealModelIds), refurbishment default' },
  patchPreferences: { method: 'PATCH', path: '/api/me/preferences', note: 'dealModelIds | savedFilters+expectedSavedFiltersRevision | refurbishmentDefault+expectedRefurbishmentDefaultRevision | defaultAssetClasses | registerDefaults' },
  dealModelMode: { method: 'GET', path: '/api/me/deal-model-mode', note: 'Investor | Home buyer experience' },
  putDealModelMode: { method: 'PUT', path: '/api/me/deal-model-mode' },
  uiConfig: { method: 'GET', path: '/api/ui-config', note: 'Google Maps key and map id' },
} as const satisfies Record<string, EndpointDef>
